/* eslint-disable array-callback-return */
/**
 * AccordionFacets template
 * ------------------------------------------------------------------------------
 * Returns an HTML string for an accordion facets using the given params.
 *
 * @param {Object} params - The parameters for rendering the accordion facets.
 */

function AccordionFacets (params) {
  if (!params) {
    return ''
  }

  const props = {
    field: params.field || '',
    name: params.name || '',
    type: params.type || '',
    values: params.data || [],
    id: params.id || '',
    min: params.min,
    max: params.max,
  }

  if (props.type === 'stats' || props.field === 'price') {
    return renderPriceFacet(props)
  }

  if (props.field === 'customFields.filters-colour') {
    return renderColorFacet(props)
  }

  return renderDefaultFacet(props)
}

function renderPriceFacet (params) {
  const priceParam = new URLSearchParams(window.location.search).get('price')
  let activeMin = null
  let activeMax = null

  if (priceParam) {
    const parts = priceParam.split('~')
    if (parts.length === 2) {
      activeMin = parseFloat(parts[0])
      activeMax = parseFloat(parts[1])
    }
  }

  const props = {
    name: params.name || '',
    boundsMin: Math.floor(params.min ?? 0),
    boundsMax: Math.ceil(params.max ?? 0),
    sliderMin: activeMin !== null ? activeMin : Math.floor(params.min ?? 0),
    sliderMax: activeMax !== null ? activeMax : Math.ceil(params.max ?? 0),
  }

  const symbol = window.theme.currencySymbol
  const idPrefix = 'ResultsFacets-Mobile'
  const chevron = `
    <svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="9.19238" width="1" height="7" transform="rotate(45 9.19238 0)" fill="currentColor"></rect>
      <rect x="0.707031" width="7" height="1" transform="rotate(45 0.707031 0)" fill="currentColor"></rect>
    </svg>
  `
  return `
    <li class="clc-ProductGridFacets_Item" data-filter-key="Price" data-collection-exposed-filters-external-el="drawerItem" >
      <details class="clc-ProductGridFacet" data-price-accordion>
        <summary class="clc-ProductGridFacet_Summary" data-range-slider-external-el="trigger">
          <span class="clc-ProductGridFacet_FilterLabel fz-16_18">
            ${props.name || 'Price'} (${symbol})
          </span>
        </summary>
        <div class="clc-ProductGridFacet_Display">
          <div class="clc-ProductGridFacet_Body" data-range-slider-external-el="container">
            <price-range class="prc-Range" data-facet-price>
              <div class="prc-Range_Column">
                <div class="prc-Range_Field">
                  <input
                    class="prc-Range_Input"
                    type="number"
                    inputmode="numeric"
                    id="${idPrefix}-Price-GTE"
                    value="${props.sliderMin}"
                    placeholder="${props.boundsMin}"
                    min="${props.boundsMin}"
                    max="${props.boundsMax}"
                    data-price-range-el="min"
                    data-range-slider-external-el="min"
                    data-facet-field="price"
                  />
                  <label class="prc-Range_Label" for="${idPrefix}-Price-GTE" data-currency-symbol="${symbol}" data-text="From">
                    <span class="util-ScreenReaderOnly">From</span>
                  </label>
                </div>
              </div>
              <div class="prc-Range_Column">
                <div class="prc-Range_Field">
                  <input
                    class="prc-Range_Input"
                    type="number"
                    inputmode="numeric"
                    id="${idPrefix}-Price-LTE"
                    value="${props.sliderMax}"
                    placeholder="${props.boundsMax}"
                    min="${props.boundsMin}"
                    max="${props.boundsMax}"
                    data-price-range-el="max"
                    data-range-slider-external-el="max"
                    data-facet-field="price"
                  />
                  <label
                    class="prc-Range_Label"
                    for="${idPrefix}-Price-LTE"
                    data-currency-symbol="${symbol}"
                    data-absolute-max="${props.boundsMax}"
                    data-text="To"
                  >
                    <span class="util-ScreenReaderOnly">To</span>
                  </label>
                </div>
              </div>
            </price-range>

            <div class="clc-ProductGridFacet_RangeSlider">
              <range-slider
                class="rng-Slider"
                min="${props.boundsMin}"
                max="${props.boundsMax}"
                min-value="${props.sliderMin}"
                max-value="${props.sliderMax}"
              >
                <button class="rng-Slider_Dot rng-Slider_Dot-left" type="button" data-range-slider-el="touchLeft">
                  <div class="rng-Slider_DotInner">
                    ${chevron}
                    <span class="rng-Slider_DotTotal" data-range-slider-el="minValue">check${
                      window.theme.currencySymbol
                    }${props.sliderMin}</span>
                  </div>
                </button>
                <button class="rng-Slider_Dot rng-Slider_Dot-right" type="button" data-range-slider-el="touchRight">
                  <div class="rng-Slider_DotInner">
                    ${chevron}
                    <span class="rng-Slider_DotTotal" data-range-slider-el="maxValue">check${
                      window.theme.currencySymbol
                    }${props.sliderMax}</span>
                  </div>
                </button>
                <div class="rng-Slider_Line" data-range-slider-el="line">
                  <span class="rng-Slider_LineInner"></span>
                  <span class="rng-Slider_LineHighlighter" data-range-slider-el="highlighter"></span>
                </div>
              </range-slider>
            </div>
          </div>
        </div>
      </details>
    </li>
  `
}

function renderDefaultFacet (props) {
  return `
    <li class="clc-ProductGridFacets_Item" data-filter-key="${
      props.field
    }" data-collection-exposed-filters-external-el="drawerItem">
       <details class="clc-ProductGridFacet">
        <summary class="clc-ProductGridFacet_Summary">
          <span class="clc-ProductGridFacet_FilterLabel fz-16_18">
            ${props.name}
          </span>
        </summary>
        <div class="clc-ProductGridFacet_Display">
           <div class="clc-ProductGridFacet_Body">
              <div
                class="clc-ProductGridFacet_List"
              >
                ${props.values
                  .map(value => {
                    return `
                     <div class="clc-ProductGridFacet_Item">
                        <div class="clc-ProductGridFacet_CheckboxContainer">
                          ${renderInput(value, props.field, props.id)}
                          <label
                            class="clc-ProductGridFacet_Label fz-14_20"
                            for="${props.id}-${props.field}-${value.value}"
                            aria-disabled="${
                              value.count === 0 && value.active === false ? 'true' : 'false'
                            }"
                          >

                          <span class="clc-ProductGridFacet_CheckboxIcon" style="--ColourSwatch_BackgroundColour: var(--Color_Grey-lightest)">
                          </span>

                          <p class="clc-ProductGridFacet_Title">
                            ${value.value}
                            ${
                              value.count !== undefined && !props.field.includes('size')
                                ? `<span class="clc-ProductGridFacet_Count">(${value.count})</span>`
                                : ''
                            }
                          </p>
                          </label>
                        </div>
                     </div>
                  `
                  })
                  .join('')}
              </div>
           </div>
        </div>
       </details>
    </li>
  `
}

function renderColorFacet (props) {
  const storeColors = window.theme.props.colorHexs

  return `
      <li class="clc-ProductGridFacets_Item" data-filter-key="${
        props.field
      }" data-collection-exposed-filters-external-el="drawerItem">
       <details class="clc-ProductGridFacet">
        <summary class="clc-ProductGridFacet_Summary">
          <span class="clc-ProductGridFacet_FilterLabel fz-16_18">
            ${props.name}
          </span>
        </summary>
        <div class="clc-ProductGridFacet_Display">
           <div class="clc-ProductGridFacet_Body">
              <div
                class="clc-ProductGridFacet_List"
              >
                ${props.values
                  .map(value => {
                    const returnedColor = storeColors[value.value.toLowerCase()]

                    const hasImage = false
                    // if (returnedColor && returnedColor.image !== null) {
                    //   hasImage = true
                    // }

                    return `
                     <div class="clc-ProductGridFacet_Item">
                        <div class="clc-ProductGridFacet_CheckboxContainer">
                          ${renderInput(value, props.field, props.id)}
                          <label
                            class="clc-ProductGridFacet_Label fz-14_20"
                            for="${props.id}-${props.field}-${value.value}"
                            aria-disabled="${
                              value.count === 0 && value.active === false ? 'true' : 'false'
                            }"
                          >

                          <span class="clc-ProductGridFacet_CheckboxIcon" style="${
                            storeColors && returnedColor
                              ? `background-color: ${returnedColor};`
                              : ''
                          }">
                            ${
                              hasImage
                                ? `<img src="${returnedColor.image}" alt="${value.value} color swatch" class="clc-ProductGridFacet_ColorImage">`
                                : ''
                            }
                          </span>
                          </span>

                          <p class="clc-ProductGridFacet_Title">
                            ${value.value}
                            ${
                              value.count !== undefined
                                ? `<span class="clc-ProductGridFacet_Count">(${value.count})</span>`
                                : ''
                            }
                          </p>
                          </label>
                        </div>
                     </div>
                  `
                  })
                  .join('')}
              </div>
           </div>
        </div>
       </details>
    </li>
  `
}

function renderInput (value, field, idPrefix) {
  if (field === 'available') {
    return `
        <input
          class="clc-ProductGridFacet_Checkbox"
          type="radio"
          name="${field}"
          data-facet-field="${field}"
          value="${value.value}"
          id="${idPrefix}-${field}-${value.value}"
          ${value.selected ? 'checked' : ''}
          ${value.count === 0 && value.selected === false ? 'disabled' : ''}
        >
    `
  } else {
    return `
       <input
          class="clc-ProductGridFacet_Checkbox"
          type="checkbox"
          name="${field}"
          data-facet-field="${field}"
          value="${value.value}"
          id="${idPrefix}-${field}-${value.value}"
          ${value.selected ? 'checked' : ''}
          ${value.count === 0 && value.selected === false ? 'disabled' : ''}
        >
    `
  }
}

window.theme.results.templates.AccordionFacets = AccordionFacets
